// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { Chip, Typography, useMediaQuery, useTheme } from '@mui/material'

// ** Icons Imports
import MenuIcon from 'mdi-material-ui/Menu'

// ** Components
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
// import { useLocation, useNavigate } from 'react-router-dom'
// import VerticalNavItems from 'src/navigation/vertical'
import Translations from '../Translations'
// import { useAppTitle } from 'src/context/AppTitleContext'
import { useAuth } from 'src/hooks/useAuth'
import LanguageDropdown from 'src/@core/layouts/components/shared-components/LanguageDropdown'
import { useTranslation } from 'react-i18next'
import GetBadgeLabel from 'src/components/GetBadgeLabel'

const AppBarContent = props => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props
  // const path = useLocation()
  // const navigations = VerticalNavItems()
  // const mainTitle = navigations?.filter(item => item.path === path.pathname)
  // const subTitle = navigations
  //   .filter(item => item.children)
  //   .map(item => item.children)
  //   .flat()
  //   .find(child => child.path === path.pathname)

  // const { title } = useAppTitle()
  // const navigate = useNavigate()
  const { user } = useAuth()
  const { t } = useTranslation()
  // Add theme and mediaQuery to check screen size
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const isAlert = user?.isAlert ?? false

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'common.white'
      }}
    >
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {isMobile ? (
          <IconButton color='inherit' sx={{ ml: 2.75 }} onClick={toggleNavVisibility}>
            <MenuIcon />
          </IconButton>
        ) : (
          <Typography fontSize='24px' color='#000000' fontWeight={700} sx={{ display: 'flex', alignItems: 'center' }}>
            {/* <Translations text={`Hello, `} /> */}
            {t('Header.Hello')}
            <span style={{ color: '#FC5722' }}>{user?.firstName}</span>
            <span style={{ color: '#000000', marginLeft: '5px' }}>&ndash; {user?.companyName}</span>
            <span style={{ color: '#8F9DAC', marginLeft: '5px', fontSize: '15px' }}>({user?.userId})</span>
            {user?.badgeLabel && <GetBadgeLabel label={user?.badgeLabel} showTooltip={true} />}
            {/* Alert / In Good Standing Chip */}
            <Chip
              label={
                isAlert
                  ? t('Badge Management Data.Alert Status')
                  : t('Badge Management Data.In Good Standing')
              }
              sx={{
                ml: 2,
                backgroundColor: isAlert ? '#FEE4E2' : '#E6F9F1',
                color: isAlert ? '#D92D20' : '#039855',
                fontWeight: 600,
                fontSize: '12px'
              }}
            />
          </Typography>
        )}
        {/* <Autocomplete hidden={hidden} settings={settings} /> */}
      </Box>
      <Box className='actions-right' gap={3} sx={{ display: 'flex', alignItems: 'center' }}>
        {/* <ModeToggler settings={settings} saveSettings={saveSettings} /> */}
        <LanguageDropdown settings={settings} saveSettings={saveSettings} />
        <NotificationDropdown settings={settings} />
        <UserDropdown settings={settings} />
      </Box>
    </Box>
  )
}

export default AppBarContent
